import React from "react";

const DeleteBlogScreen = () => {
  return <div>DeleteBlogScreen</div>;
};

export default DeleteBlogScreen;
